export default {
  /**
   * Get value of a GET query string param based on a given name.
   * E.g. "?Search=foo&somethingElese=bar" => "foo"
   *
   * @param {string} locationSearchString `window.location.serach` usually
   * @param {string} name The name of query string param
   *
   * @return {string}
   */
  getQueryStringParam: function (locationSearchString, name) { // eslint-disable-line
    // E.g. "?Search=foo&somethingElese=bar" => "Search=foo"
    const searchKeywordPart = locationSearchString.replace(/^\?/, '').split('&').find(s => s.includes(`${name}=`));

    if (searchKeywordPart && searchKeywordPart.includes('=')) {
      return searchKeywordPart.split('=')[1];
    }

    return '';
  },
};
